import { Notification } from 'grommet';
import React, { createContext, useState, useCallback, useMemo, useRef } from 'react';
export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState(null);
    const hideTimeoutRef = useRef(null);

    const showNotification = useCallback((message, type = 'info', timeout = 3000) => {
        // clear any pending hide so it can't clear out this newer notification early
        if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
        setNotification({ message, type });
        hideTimeoutRef.current = setTimeout(() => setNotification(null), timeout)
    }, [])

    // stable value so consumers don't re-render on every toast show/auto-hide
    const contextValue = useMemo(() => ({ showNotification }), [showNotification])

    return (<NotificationContext.Provider value={contextValue}>
        {children}
        {notification && (
            <Notification toast status={notification.type} message={notification.message} onClose={() => { setNotification(null) }} />
        )}
    </NotificationContext.Provider>)
}